import * as Translator from './bazinga-translator';

window.Translator = Translator;



// WEBPACK FOOTER //
// ./assets/Translation/js/translator/index.js